import { inject } from '@vue/composition-api';
import { experimentProviderName } from './constants.js';

function useExperimentContext() {
    var context = inject(experimentProviderName);
    if (!context) {
        throw new Error('You must use this within an ExperimentProvider.');
    }
    return context;
}

export { useExperimentContext };
